export default __webpack_public_path__ + "static/media/sensotrend_uploader_login2.8ab86b76.png";